const leadsListStore = (apiServices => ({
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state: {
    leadsList: [],
  },
  mutations: {
    setLeadsList: (state, leadsListObj) => {
      state.leadsList = leadsListObj; // eslint-disable-line no-param-reassign
    },
  },
  actions: {
    async loadLeadsList(context, payload) {
      return apiServices.oa.leadAgent.getLeadsForAgent(payload.agentKey)
        .then((leadsList) => {
          const list = [];
          for (let i = 0; i < leadsList.leadagentmappingsinfo.length; i += 1) {
            const { lam } = leadsList.leadagentmappingsinfo[i];
            lam.leadinfo = leadsList.leadagentmappingsinfo[i].leadinfo;
            list.push(lam);
          }
          context.commit('setLeadsList', list);
        });
    },
    refreshLeadsList(context, payload) {
      if (!payload.leadsList) {
        // get the list of leads from API when the list does not exist yet
        context.dispatch('loadLeadsList', payload)
          .then((leadsList) => {
            payload.leadsList = leadsList; // eslint-disable-line no-param-reassign
            context.dispatch('refreshLeadAgentMappingInList', payload);
          });
      } else {
        context.dispatch('refreshLeadAgentMappingInList', payload);
      }
    },
    refreshLeadAgentMappingInList({ commit }, payload) {
      if (payload.leadsList) {
        // Find the LAM from the leads list and replace its info in the list
        for (let i = 0; i < payload.leadsList.length; i += 1) {
          if (payload.leadsList[i].id === payload.lam.id) {
            // LAM updates do not return leadinfo
            // so let's save the existing one in the updated LAM object
            payload.lam.leadinfo = payload.leadsList[i].leadinfo; // eslint-disable-line no-param-reassign
            payload.leadsList[i] = payload.lam; // eslint-disable-line no-param-reassign
          }
        }
        commit('setLeadsList', payload.leadsList);
      }
    },
  },
}));

export default leadsListStore;
